import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/services", label: "Services" },
  { to: "/our-clients", label: "Our Clients" },
  { to: "/team", label: "The Practice" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <div className="w-9 h-9 bg-[#0F292F] flex items-center justify-center">
            <span className="font-serif text-[#CFA968] text-xl leading-none">H</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg tracking-tight text-[#0F292F]">H. Elliot Associates</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#52525B]">Financial Planning · Retirement · Tax</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `he-link text-sm tracking-wide font-medium transition-colors ${
                  isActive ? "text-[#8E6A2B]" : "text-[#1A1A1A] hover:text-[#8E6A2B]"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <Link to="/portal/login" data-testid="header-portal-link" className="text-sm tracking-wide font-medium text-[#1A1A1A] he-link">
            Client Portal
          </Link>
          <Link to="/book" data-testid="header-book-btn" className="btn-primary">
            Book a Consultation
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden w-10 h-10 flex items-center justify-center text-[#0F292F]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-black/5 bg-[#F9F8F6]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-[#1A1A1A]"
              >
                {n.label}
              </Link>
            ))}
            <div className="hairline my-2" />
            <Link to="/portal/login" onClick={() => setOpen(false)} className="text-sm font-medium">
              Client Portal
            </Link>
            <Link to="/book" onClick={() => setOpen(false)} className="btn-primary justify-center">
              Book a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
